export default {"src":"/_next/static/media/pin_cocktail.e1383111.svg","height":29,"width":21,"blurWidth":0,"blurHeight":0};